import * as React from "react";
import { useParams } from "react-router-dom";
import { useGetUserQuery } from "../../store/api/userApi";
import { UserDetailForm } from "./detailForm";
import { Loader } from "../../components/layout/loader";
import { IncorrectItem } from "../../components/generic/IncorrectItem/incorrectItem";
import { AccessRestrictedItem } from "../../components/generic/AccessRestrictedItem/accessRestrictedItem";

type RouteParams = "org" | "idOrEmail";
export const UserDetailInitializer: React.FC = () => {
  const { org: orgName, idOrEmail } = useParams<RouteParams>();

  const selfLink = `/org/${orgName}/user/${idOrEmail}`;
  const { data: user, isLoading, isError, error, refetch } = useGetUserQuery(selfLink || "", {
    skip: !selfLink,
    refetchOnMountOrArgChange: true,
  });

  if (!user && isLoading) {
    return <Loader />;
  }

  const is403 = isError && (error as any)?.status === 403;
  if (is403) {
    return <AccessRestrictedItem kind="user" />;
  }

  const is404 = isError && (error as any)?.status === 404;
  if (is404 || !user) {
    return <IncorrectItem kind="user" canCreate={false} />;
  }

  return <UserDetailForm user={user} />;
};
